import { useNavigate, Link } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { logout } from '../lib/phpAuth'
import { Header } from '../components/Header'
import './GuestView.css'

function GuestView() {
  const navigate = useNavigate()
  const { user, loading: authLoading } = useAuth()

  const handleLogout = async () => {
    try {
      await logout()
      localStorage.clear()
      window.location.href = '/'
    } catch (error) {
      console.error('Logout error:', error)
      localStorage.clear()
      window.location.href = '/'
    }
  }

  if (authLoading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
      }}>
        <div style={{
          fontSize: '1.1rem',
          color: '#666',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1rem',
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #14b8a6',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
          }} />
          <div>Načítání...</div>
        </div>
      </div>
    )
  }

  return (
    <div className="guest-view">
      <Header
        leftButtons={
          <>
            <button
              onClick={() => navigate('/')}
              className="back-button"
            >
              ← Zpět
            </button>
            <h1 style={{ margin: 0, fontSize: '1.5rem' }}>Vítejte na stránkách školy</h1>
          </>
        }
        rightContent={
          user ? (
            <button
              onClick={handleLogout}
              className="logout-button"
            >
              Odhlásit se
            </button>
          ) : null
        }
        showLogo={true}
      />
      <div className="guest-container">
        <div className="guest-content">
          <section className="guest-section quick-links">
            <h2>Rychlé odkazy</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
              <a
                href="https://www.isscheb.eu/"
                target="_blank"
                rel="noopener noreferrer"
                className="guest-link-card"
              >
                <h3>Web školy</h3>
                <p>Oficiální stránky ISŠ Cheb</p>
              </a>
              <Link to="/calendar" className="guest-link-card">
                <h3>Kalendář akcí</h3>
                <p>Veřejný kalendář školních akcí</p>
              </Link>
              <Link to="/school-employees" className="guest-link-card">
                <h3>Seznam zaměstnanců</h3>
                <p>Telefonní seznam školy</p>
              </Link>
              <Link to="/public-canteen" className="guest-link-card">
                <h3>Školní jídelna</h3>
                <p>Hodnocení a informace o stravování</p>
              </Link>
            </div>
          </section>

          <section className="guest-section">
            <h2>O škole</h2>
            <p>
              Integrovaná střední škola Cheb poskytuje vzdělání v oborech středního a vyššího odborného vzdělávání.
              Naše škola nabízí moderní vybavení, kvalifikované učitele a praktické vyučování.
            </p>
          </section>

          <section className="guest-section">
            <h2>Služby pro veřejnost</h2>
            <ul>
              <li><strong>Vzorková prodejna ve Špalíčku</strong> - Prodej výrobků studentů</li>
              <li><strong>Kadeřnictví</strong> - Kadeřnické služby pro veřejnost</li>
              <li><strong>Svářečská škola</strong> - Kurzy a certifikace svářečských prací</li>
              <li><strong>Rekvalifikační kurzy</strong> - Další vzdělávání a rekvalifikace</li>
              <li><strong>Přípravné kurzy</strong> - Příprava na přijímací zkoušky</li>
              <li><strong>Truhlářská výroba</strong> - Výroba nábytku a dřevěných výrobků</li>
              <li><strong>Zahradnické práce</strong> - Údržba zeleně a zahradnické služby</li>
              <li><strong>Elektroinstalační práce</strong> - Instalace a opravy elektrických zařízení</li>
              <li><strong>Instalatérské práce</strong> - Instalace a opravy vodovodních a topných systémů</li>
            </ul>
          </section>

          <section className="guest-section">
            <h2>Kontaktní informace</h2>
            <p>
              Pro více informací o naší škole, studijních programech nebo přijímacím řízení navštivte
              naše oficiální webové stránky: <a href="https://www.isscheb.eu/" target="_blank" rel="noopener noreferrer" style={{ color: '#14b8a6', textDecoration: 'none', fontWeight: '600' }}>www.isscheb.eu</a>
            </p>
            <p>
              <strong>Oficiální název:</strong> Integrovaná střední škola Cheb, příspěvková organizace<br />
              <strong>Webové stránky:</strong> <a href="https://www.isscheb.eu/" target="_blank" rel="noopener noreferrer" style={{ color: '#14b8a6', textDecoration: 'none', fontWeight: '600' }}>www.isscheb.eu</a>
            </p>
          </section>

          <section className="guest-section">
            <h2>Pro zaměstnance školy</h2>
            <p>
              Pokud jste zaměstnanec školy s e-mailem <strong>@iss-cheb.cz</strong>, přihlaste se
              pomocí tlačítka Office 365 na úvodní stránce pro přístup k intranetu a interním službám.
            </p>
          </section>

          <section className="guest-section" style={{ textAlign: 'center', paddingTop: '2rem', borderTop: '1px solid #e0e0e0', marginTop: '2rem' }}>
            <p style={{ marginBottom: '1rem', color: '#666' }}>
              <Link
                to="/privacy-policy"
                style={{
                  color: '#667eea',
                  textDecoration: 'none',
                  fontWeight: '500',
                  fontSize: '0.95rem',
                }}
              >
                Zásady ochrany osobních údajů (GDPR)
              </Link>
            </p>
            <p style={{ fontSize: '0.85rem', color: '#999', margin: 0 }}>
              © {new Date().getFullYear()} Integrovaná střední škola Cheb
            </p>
          </section>
        </div>
      </div>
    </div>
  )
}

export default GuestView
